// お問い合わせページ（/contact）の入力画面用スクリプト
// 1. ラジオボタンで2つのフォーム（購入チケットのキャンセル / その他）を切り替える
// 2. メールアドレスと確認用メールアドレスの一致チェック
// 3. 「プライバシーポリシーに同意する」がONの時だけ確認ボタンを有効化する

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.js-contact-forms');
  if (!container) return;

  const switches = container.querySelectorAll('.js-contact-form-switch');
  const forms = container.querySelectorAll('.js-contact-form');

  // 同意チェックの状態に応じて確認ボタンの有効/無効を切り替える
  function updateSubmitState(form) {
    const agree = form.querySelector('.js-contact-agree');
    const submit = form.querySelector('.js-contact-submit');
    if (!agree || !submit) return;
    submit.disabled = !agree.checked;
  }

  function showSelectedForm() {
    const selected = container.querySelector('.js-contact-form-switch:checked');
    if (!selected) return;
    forms.forEach(function (form) {
      const match = form.dataset.formType === selected.value;
      form.classList.toggle('d-none', !match);
      // 非表示フォームの必須項目がブラウザ検証で引っかからないよう無効化する
      form.querySelectorAll('input, select, textarea').forEach(function (field) {
        field.disabled = !match;
      });
      if (match) updateSubmitState(form);
    });
  }

  switches.forEach(function (radio) {
    radio.addEventListener('change', showSelectedForm);
  });

  forms.forEach(function (form) {
    // 同意チェック
    const agree = form.querySelector('.js-contact-agree');
    if (agree) {
      agree.addEventListener('change', function () {
        updateSubmitState(form);
      });
    }

    // メールアドレスの一致チェック
    const email = form.querySelector('.js-contact-email');
    const confirmation = form.querySelector('.js-contact-email-confirmation');
    if (email && confirmation) {
      const validateMatch = function () {
        if (confirmation.value && email.value !== confirmation.value) {
          confirmation.setCustomValidity('メールアドレスが一致しません。');
          confirmation.classList.add('is-invalid');
        } else {
          confirmation.setCustomValidity('');
          confirmation.classList.remove('is-invalid');
        }
      };
      email.addEventListener('input', validateMatch);
      confirmation.addEventListener('input', validateMatch);
    }
  });

  showSelectedForm();
});
